(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-branches"]) return;
  try {
    
  class StoreLocator extends HTMLElement {
    constructor() {
      super();
      this.locatorActions = this.querySelector('template').content;
      this.locatorActions.select = this.locatorActions.querySelector('select');
      let optionsHtml = '';
      document.querySelectorAll('.storegroupd-title').forEach((storeGroup) => {
        optionsHtml += `<option value="${storeGroup.id}">${storeGroup.id.replace('-', ' ')}</option>`;
      });
      this.locatorActions.select.innerHTML += optionsHtml;
      document.querySelector('.shopify-section.storelocator').after(this.locatorActions);
      this.scrollContainer = document.querySelector('.page-storelocator');
      this.mql = window.matchMedia('(min-width: 750px)');
      this.locatorActions.select.addEventListener('change', this.onChange.bind(this));
    }

    onChange(event) {
      const value = event.target.value;

      if (value) {
        location.hash = value;
      }
    }
  }
  customElements.define('store-locator', StoreLocator);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-brands"] && !Shopify.designMode) return;
  try {
    
    class Brands extends HTMLElement {
        constructor() {
            super();
            this.currentLetter;
            this.prevLetter;
            
            let letters =  this.querySelectorAll('.brand-initial'); 
            
            letters.forEach((letter)=> {
                letter.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.scrollToBrand(e.target);
                    return false;
                }); 
            });
            this.reorderBrands();
          
        
        }
        scrollToBrand(letter) {
            this.setCurrentLetter(letter);
            let headerHeight = document.querySelector('header').offsetHeight          
            let elem = this.querySelector('#'+letter.innerHTML)
            const y = elem.getBoundingClientRect().top + window.scrollY;
            window.scroll({
                top: y,
                behavior: 'smooth'
            });
        }
        setCurrentLetter(letter) {
            if (this.currentLetter) {
                this.prevLetter = this.currentLetter;
                this.prevLetter.style.fontWeight = 'normal';
                this.prevLetter.style.borderBottom = 'unset';
            }
            this.currentLetter = letter;
            this.currentLetter.style.fontWeight = 'bold';
            this.currentLetter.style.borderBottom = '1px solid black';
        }
        reorderBrands() {
            let mq = window.matchMedia("(min-width: 750px)");
            if (mq.matches) {
                let brands = this.querySelector('.brands');
                let screenWidth = brands.offsetWidth;
                let brands_num = brands.querySelectorAll('ul').length;
                let brands_in_col;
                //calculate number of brands per col
                brands_in_col =  Math.round(brands_num / 4);
                let brands_counter = 1;
                let col_index = 1;
                brands.querySelectorAll('ul').forEach(function(brand, index){
                if(brands_counter == brands_in_col){
                    brands.querySelector('.col-' + col_index + '').appendChild(brand);
                    brands_counter = 1;
                    col_index++;
                } else {
                var col;
                if(brands_counter == 1){
                    col = document.createElement('div');
                    col.classList.add('col');
                    col.classList.add('col-' + col_index);
                    col.appendChild(brand);
                    brands.appendChild(col);
                } else {
                    brands.querySelector('.col-' + col_index + '').appendChild(brand);
                }
                brands_counter++;
                }
                })
                brands.style.display = 'flex';
            } 
        }
    }
    customElements.define('brands-collection', Brands);
  
  } catch(e) { console.error(e); }
})();
})();
